import styled from 'styled-components';
export const LoginWrap = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  height:100vh;
`;
export const FormInput = styled.input`
  outline: none;
  width: 425px;
  height: 26px;
  flex-shrink: 0;
  margin-top: 5px;
  margin-bottom: 15px;
  border: 1px solid #d3d3d3;
`;
export const FormButton = styled.button`
  margin-top: 45px;
  cursor: pointer;
  border-radius: 2px;
  background: #001d3d;
  color: #fff;
  display: flex;
  align-items: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border-style: none;
  width: 69px;
  height: 24px;
  justify-content: center;
  flex-shrink: 0;
`;
export const InputWrap = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;
export const LogForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const ShowBtn = styled.button`
  position: absolute;
  right: 5px;
  top: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  cursor: pointer;
`;